import React from 'react'

import AdminWrapper from '../AdminWrapper'
import CollegeHomeContainer from '../../Container/CollegeHomeContainer'
import { detailTabs, updateTabActiveStatus } from './DetailTabsDefinition'

const DetailsHolder = ({ children, college, activePath }) => {
  updateTabActiveStatus(activePath)

  return (
    <AdminWrapper>
      <CollegeHomeContainer
        user={college.user}
        institution={college.institution}
        tabs={detailTabs}
        hideViewBar={true}
        isViewAsTeacher={true}
        isSeparateTabsWithLogo={true}
        isSkipInnerSpacing={true}
      >
        {children}
      </CollegeHomeContainer>
    </AdminWrapper>
  )
}

export default DetailsHolder
